import { isObject, isString, isNumber } from "../../object";
import { HttpServerException } from "./httpServerException";

class JsCaptureException {

    constructor() {
        this.isOpenHttpServer = true;
        this.option = {};
        this.master = null;
    }

    init(master, option) {
        master.util.log("JsCaptureException-master:", master);
        master.util.log("JsCaptureException-option:", option);

        this.option = option;
        this.master = master;
        
        var that = this;
        var tagNames = ['audio','img','video','script','source','link'];
        window.addEventListener('error', (e) => {
            // console.log('捕获到异常error：', e);
            if (e.error) {
                // console.log('可以捕获到错误堆栈信息。');
                // console.log("e.name:",e.error.name);
                this.captureEvent(e.error.name, e.error.stack, e.message, '');

            } else {//支持tagNames 加载
                console.log("srcTarget:", e.target.tagName);
                var tagName = e.target.tagName;
                if (!tagName) return;
                if (tagNames.includes(tagName.toLowerCase())){
                    var dom = e.target;
                // console.log("dom-src:", dom.src);
                var type = "ResourseError:" + e.target.tagName;
                var message = dom.src;
                if(!message){
                    message = dom.href;
                }
                this.captureEvent(type, '', message, '');
                }
            }
                // console.log("dom-src:", dom.src);
        }, true);

        window.addEventListener("unhandledrejection", function (e) {
            e.preventDefault()
            // console.log('捕获到异常unhandledrejection:', e);
            that.enhanceEventByUnhandleRejection(e);
            return true;//捕获异常后，抛出异常。
        });

        if (this.option.isOpenHttpServer) {
            this.isOpenHttpServer = this.option.isOpenHttpServer;
        }

        if (this.isOpenHttpServer) {
            const httpServerException = new HttpServerException();
            httpServerException.init(option);
            httpServerException.sendError = function (err) {
                // console.log("err:", err);
                that.captureEvent(err.name, err.stack, err.message, '');
            }
            httpServerException.sendHttpServerError = function (type, stacktrace, message, name) {
                that.captureEvent(type, stacktrace, message, name);
            }
        }
        // this.startPageCrash();
    }


    captureException(exception) {
        // console.log("captureException:", exception);

        if (Object.prototype.toString.call(exception) === "[object Error]") {
            var error = exception;
            this.captureEvent(error.name, error.stack, error.message, "custom");
        } else {
            console.log("captureException：请检查下当前对象是否为Error对象");
        }
    }

    captureEvent(type, stacktrace, message, name) {
        // console.log("message:",Object.prototype.toString.call(message));
        try {
            var params = {
                c: 'radar_error',
                type: type,
                stacktrace: stacktrace ? stacktrace : '',
                message: message ? message : '',
                name: name
            };
            this.sendLog(params);
        } catch (aaa) { }
    }


    enhanceEventByUnhandleRejection(e) {
        let error = e;
        try {
            if ('reason' in e) {
                error = e.reason;
            } else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }

        } catch (aaa) { }

        // console.log("enhanceEventByUnhandleRejection:", error);
        this.isPrimitive(error) ? this.eventFromRejectionWithPrimitive(error) : this.eventFromUnknownInput(error);
    }


    //发送事件
    sendLog(value) {
        if (this.master && Object.prototype.toString.call(this.master) === '[object Object]') {
            this.master.log(value, 'wpo');
        }
    }


    // Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
    isPrimitive(wat) {
        return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
    }


    eventFromRejectionWithPrimitive(e) {

        var reason = '';

        if (isString(e) || isNumber(e)) {
            reason = String(e);
        }
        else if (e === undefined) {
            reason = 'undefined';
        }
        else if (e === null) {
            reason = 'null';
        }
        // console.log("reason:", reason);
        var message = 'Non-Error promise rejection captured with value:' + reason;

        this.captureEvent('UnhandledRejection', '', message, '');

    }


    eventFromUnknownInput(e) {
        // console.log("eventFromUnknownInput", e);
        var reason, msg, st;

        if (isObject(e)) {
            try {
                reason = e.stack;
                if (!reason) {
                    var keys = Object.keys(e);
                    reason = keys.toString();
                    msg = 'Non-Error promise rejection captured with value:' + reason;
                } else {
                    st = reason;
                }
            } catch (aaa) { }
        }

        // console.log("reason:", reason);
        this.captureEvent('UnhandledRejection', st, msg, '');
    }


    // startPageCrash() {

    //     window.addEventListener('load', function () {
    //         console.log("window.load==页面加载");
    //         sessionStorage.setItem('good_exit', 'pending');
    //         setInterval(() => {
    //             sessionStorage.setItem('time_before_crash', new Date().toString());
    //         }, 1000);
    //     });

    //     window.addEventListener('beforeunload', function () {
    //         console.log("window.beforeunload==页面结束");
    //         sessionStorage.setItem('good_exit', 'true');
    //     });

    //     if (sessionStorage.getItem('good_exit') && sessionStorage.getItem('good_exit') !== 'true') {
    //         console.log("当前页面没有正常关闭！", sessionStorage.getItem('time_before_crash'));
    //     }
    // }

}



export const exception = new JsCaptureException();

if (window.RADAR_MONITOR_WEBJSSDKPLUGIN && Object.prototype.toString.call(window.RADAR_MONITOR_WEBJSSDKPLUGIN) === '[object Object]') {
    window.RADAR_MONITOR_WEBJSSDKPLUGIN.exception = exception;
} else {
    window.RADAR_MONITOR_WEBJSSDKPLUGIN = { exception: exception }
}